import axios from 'axios';
import * as ActionCreators from './actionCreators';
import { getHistoryType } from '../actions/sharedActions';

export function createPrivacyLink(locale) {
  return dispatch => {
    const localeTable = {
      en: 'en_US',
      ja: 'ja_JP',
      zh: 'zh_CN',
      fr: 'fr_FR',
      es: 'es_ES',
      pt: 'pt_PT',
      it: 'it_IT',
      de: 'de_DE',
      nl: 'nl_NL',
      ar: 'ar_SA',
      'en-US': 'en_US',
      'en-GB': 'en_GB',
      'fr-FR': 'fr_FR',
      'fr-CA': 'fr_CA',
      'es-MX': 'es_MX',
      'es-ES': 'es_ES',
      'pt-PT': 'pt_PT',
      'pt-BR': 'pt_BR',
      'it-IT': 'it_IT',
      'de-DE': 'de_DE',
      'nl-NL': 'nl_NL',
      'zh-CN': 'zh_CN',
      'zh-HK': 'zh_HK',
      'ar-SA': 'ar_SA',
      'ja-JP': 'ja_JP',
    };
    const privacyPolicyLink = `//www.awardselect.com/privacy/p_${
      localeTable[locale]
    }.html`;

    dispatch(ActionCreators.updatePrivacyPolicyLink(privacyPolicyLink));
  };
}

export function getTranslations(locale, fromUpdateLocale) {
  return (dispatch, getState) => {
    const config = locale ? { headers: { 'Accept-Language': locale } } : {};
    const { translations } = getState();
    const translationsURL = getHistoryType().isIE9
      ? `${getState().basePath}/api/translations?q=${Date.now()}`
      : `${getState().basePath}/api/translations`; // Checks for IE9 and adds query param to prevent caching requests

    if (
      !fromUpdateLocale &&
      Object.keys(translations).length !== 0 &&
      JSON.stringify(translations) !== JSON.stringify({})
    ) {
      dispatch(ActionCreators.updateTranslations(translations));
      return dispatch(ActionCreators.changeLocale(locale));
    }
    return axios
      .get(translationsURL, config)
      .then(response => {
        dispatch(ActionCreators.updateTranslations(response.data.translations));
        dispatch(createPrivacyLink(response.data.locale));
        dispatch(ActionCreators.changeLocale(response.data.locale));
      })
      .catch(() => {});
  };
}

export function updateLocale() {
  const e = document.getElementById('language-select');
  const locale = e.options[e.selectedIndex].value;
  return dispatch => {
    dispatch(getTranslations(locale, true));
  };
}
